export default __webpack_public_path__ + "static/media/mutual-ic-pickup.b6400165.svg";